(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"]) return;
  try {
    
  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    if (slider.dataset.initialized === 'true') return;
    slider.dataset.initialized = 'true';

    const slides = Array.from(slider.querySelectorAll('.hero__slide'));
    const prev = slider.querySelector('[data-hero-prev]');
    const next = slider.querySelector('[data-hero-next]');
    const dotsContainer = slider.querySelector('[data-hero-dots]');

    if (slides.length <= 1) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      if (dotsContainer) dotsContainer.style.display = 'none';
      return;
    }

    let current = 0;

    slides.forEach((_, index) => {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'hero__dot';
      dot.setAttribute('aria-label', `Bild ${index + 1} anzeigen`);

      if (index === 0) {
        dot.classList.add('is-active');
      }

      dot.addEventListener('click', () => {
        showSlide(index);
      });

      dotsContainer.appendChild(dot);
    });

    const dots = Array.from(
      dotsContainer.querySelectorAll('.hero__dot')
    );

    function showSlide(index) {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    }

    prev.addEventListener('click', () => {
      showSlide(current - 1);
    });

    next.addEventListener('click', () => {
      showSlide(current + 1);
    });

    let touchStartX = 0;

    slider.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchend',
      (event) => {
        const touchEndX = event.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) < 50) return;

        if (diff > 0) {
          showSlide(current + 1);
        } else {
          showSlide(current - 1);
        }
      },
      { passive: true }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-selector"]) return;
  try {
    
  (function () {
    function init(root) {
      var hotspots = root.querySelectorAll('[data-hotspot]');
      var panels = root.querySelectorAll('[data-set-selector-panel]');
      var defaultText = root.querySelector('[data-set-selector-default]');
      var submitButton = root.querySelector('[data-set-selector-submit]');
      var errorEl = root.querySelector('[data-set-selector-error]');
      var mobileQuery = window.matchMedia('(max-width: 900px)');

      function openPanels() {
        if (mobileQuery.matches) {
          return Array.prototype.slice.call(panels);
        }
        return Array.prototype.filter.call(panels, function (panel) {
          return panel.classList.contains('is-active');
        });
      }

      function selectedVariant(panel) {
        return panel.querySelector('.product-panel__size-input:checked');
      }

      function hideError() {
        if (!errorEl) return;
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      function updateSubmitState() {
        if (!submitButton) return;

        var open = openPanels();
        var ready = open.filter(selectedVariant);

        var label;
        if (ready.length === 0) {
          label = submitButton.getAttribute('data-label-choose');
        } else if (ready.length === 1) {
          label = submitButton.getAttribute('data-label-one');
        } else {
          label = submitButton.getAttribute('data-label-both');
        }
        submitButton.textContent = label;
      }

      function anyPanelOpen() {
        if (mobileQuery.matches) return true;
        return Array.prototype.some.call(panels, function (panel) {
          return panel.classList.contains('is-active');
        });
      }

      function firstOpenPanelWithoutSize() {
        var open = openPanels();
        for (var i = 0; i < open.length; i++) {
          if (!selectedVariant(open[i])) return open[i];
        }
        return null;
      }

      function highlightPanel(panel) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        panel.classList.add('set-selector__panel--highlight');
        window.setTimeout(function () {
          panel.classList.remove('set-selector__panel--highlight');
        }, 900);
      }

      var lastCheckedByGroup = {};

      function handleSizeInputClick(event) {
        var input = event.target.closest('.product-panel__size-input');
        if (!input) return;

        var name = input.name;
        if (input.checked && lastCheckedByGroup[name] === input) {
          input.checked = false;
          lastCheckedByGroup[name] = null;
          updateSubmitState();
        } else if (input.checked) {
          lastCheckedByGroup[name] = input;
        }
      }

      function toggle(key) {
        var panel = root.querySelector('[data-set-selector-panel="' + key + '"]');
        var hotspot = root.querySelector('[data-hotspot="' + key + '"]');
        if (!panel || !hotspot) return;

        var isActive = panel.classList.toggle('is-active');
        hotspot.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        var anyActive = Array.prototype.some.call(panels, function (p) {
          return p.classList.contains('is-active');
        });
        if (defaultText) defaultText.hidden = anyActive;

        updateSubmitState();
      }

      function submitPreorder() {
        var items = openPanels()
          .map(function (panel) {
            var variant = selectedVariant(panel);
            if (!variant) return null;

            var panelRoot = panel.querySelector('[data-product-panel]');
            var note = panelRoot ? panelRoot.getAttribute('data-preorder-note') : '';

            return {
              id: parseInt(variant.value, 10),
              quantity: 1,
              properties: note ? { Vorbestellung: note } : {},
            };
          })
          .filter(Boolean);

        if (!items.length) return;

        var cartApi = window.Aystellar && window.Aystellar.cart;
        if (!cartApi) {
          showError(submitButton.getAttribute('data-error-message'));
          return;
        }

        hideError();
        submitButton.disabled = true;

        cartApi
          .addItems(items)
          .catch(function (error) {
            showError((error && error.message) || submitButton.getAttribute('data-error-message'));
          })
          .finally(function () {
            submitButton.disabled = false;
            updateSubmitState();
          });
      }

      function handleSubmitClick() {
        if (!anyPanelOpen()) {
          hotspots.forEach(function (hotspot) {
            toggle(hotspot.getAttribute('data-hotspot'));
          });
          return;
        }

        var missing = firstOpenPanelWithoutSize();
        if (missing) {
          highlightPanel(missing);
          return;
        }

        submitPreorder();
      }

      hotspots.forEach(function (hotspot) {
        hotspot.addEventListener('click', function () {
          toggle(hotspot.getAttribute('data-hotspot'));
        });
      });

      panels.forEach(function (panel) {
        panel.addEventListener('change', updateSubmitState);
        panel.addEventListener('click', handleSizeInputClick);
      });

      if (submitButton) {
        submitButton.addEventListener('click', handleSubmitClick);
      }

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', updateSubmitState);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(updateSubmitState);
      }

      updateSubmitState();
    }

    document.querySelectorAll('[data-set-selector]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
